import { valueStoreFactory } from 'services/utils/valueStoreFactory';

export const TEMP_HACK_REMOVE = valueStoreFactory();
